import React from "react"
import { navigate, Link } from "gatsby";

import moment from "moment";
import Img from "gatsby-image"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Container from "../components/container"
import styled from "@emotion/styled"
import axios from "axios"
import {loadStripe} from '@stripe/stripe-js';
import {
  Heading, 
  Box, 
  Button,
  Spinner, 
  ButtonGroup, 
  SimpleGrid, 
  Stat, 
  StatHelpText, 
  StatNumber, 
  Link as ChakraLink, 
  PseudoBox, 
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure, 
  FormControl, 
  FormLabel, 
  Input, 
  Icon, 
} from "@chakra-ui/core";
import theme from "../theme"

const isBrowser = typeof window !== 'undefined';
const firebaseui = isBrowser ? require("firebaseui") : "div"
const firebase = isBrowser ? require('firebase/app') : '';
const firestore = isBrowser ? require('firebase/firestore') : ''


if (typeof window !== "undefined" && !firebase.apps.length) {
    // Your web app's Firebase configuration
    var firebaseConfig = {
      apiKey: "AIzaSyCY9hKCEecimNVPADkEGiRV_hbQa3aVthM",
      authDomain: "prolific-coast-seeds.firebaseapp.com",
      databaseURL: "https://prolific-coast-seeds.firebaseio.com",
      projectId: "prolific-coast-seeds",
      storageBucket: "prolific-coast-seeds.appspot.com",
      messagingSenderId: "429511362827",
      appId: "1:429511362827:web:5bbd6a6ad41526c84a3a0e"
    }
    // Initialize Firebase
    firebase.initializeApp(firebaseConfig);
  }


const Styles = styled.div`
    // box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
    // grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
`

export default class extends React.Component {
  constructor ( props ) {
    super();
    this.state = {};
  }

  async shipping ( address ) {
    let customer = await axios({
      method: 'get',
      url: 'https://prolific-coast-seeds.herokuapp.com/update_address?customer_id=' + this.state.profileData.stripeCustomerId + "&name=" + address.name + "&line1=" + address.line1 + "&line2=" + (address.line2 || "") + "&city=" + address.city + "&state=" + address.state + "&country=" + address.country + "&postal_code=" + address.postal_code,
    }) 

    if (customer.data.customer) {
      this.setState({
        customer: customer.data.customer
      })
    }
  }

  async setUser ( user ) {
    if ( user ) {
      this.setState({ user })

      let profile = await firebase.firestore().collection("profiles").doc( user.providerData[0].email ).get();
      
      if ( profile.exists ) {
        // get customer 
        this.setState({ profileData: profile.data() })

        let customer = await axios({
          method: 'get',
          url: 'https://prolific-coast-seeds.herokuapp.com/get_customer?customer_id=' + profile.data().stripeCustomerId ,
        })

        this.setState({
          customer: customer.data.customer
        })

        if ( customer.data.customer.subscriptions.data[0] ) {
          let plan;
          switch (customer.data.customer.subscriptions.data[0].plan.id ) {
            case "price_HNlGxGRCM3kn7Z":
              plan = "Bronze Plan"
              break;

            case "price_HLpDrWHzp0t9hu":
              plan = "Silver Plan"
              break;

            case "price_HNeSqm8swLXP23":
              plan = "Gold Plan"
              break;
          
            default:
              break;
          }

          let manage = await axios({
            method: 'get',
            url: 'https://prolific-coast-seeds.herokuapp.com/session?customer_id=' + profile.data().stripeCustomerId ,
          })

          this.setState({
            manage:  manage.data.message.url, 
            plan, 
          })
        } else {
          let subscriptions = await axios({
            method: 'get',
            url: 'https://prolific-coast-seeds.herokuapp.com/checkout?customer_id=' + profile.data().stripeCustomerId + "&customer_email=" + user.providerData[0].email ,
          })

          this.setState({
            gold: subscriptions.data.plans.gold, 
            silver: subscriptions.data.plans.silver, 
            bronze: subscriptions.data.plans.bronze,
          })
        }
      } 
    } else {
      var ui =
      firebaseui.auth.AuthUI.getInstance() ||
      new firebaseui.auth.AuthUI(firebase.auth())

    ui.start("#firebaseui-auth-container", {
      // signInSuccessUrl: "/account",
      tosUrl: "/terms-of-service/",
      callbacks: {
        signInSuccessWithAuthResult: function(result, redirectUrl) {
          this.handleResult(result)
        }.bind(this),
      },
      privacyPolicyUrl: "/privacy-policy",
      signInOptions: [

        {
          provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
          scopes: ["email"],
        },

        {
          provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          scopes: ["email"],
        },


        {
          provider: firebase.auth.TwitterAuthProvider.PROVIDER_ID,
          scopes: ["email"],
        },
       
        {
          provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
          scopes: ["email"],
        },


      ],
    })
    }
  }

  

  async componentDidMount ( ) {

    
    firebase.auth().onAuthStateChanged( this.setUser.bind(this) )
    // let resp = await axios({
    //   method: "post",
    //   url: `https://api.stripe.com/v1/billing_portal/sessions`,
    //   headers: {
    //     "Content-Type": "application/x-www-form-urlencoded",
    //     Authorization: "Bearer pk_live_ccEhvOS5yGirpesbKDOeagQh00T3UqtHwp",
    //   },
    // })

    if (typeof window === undefined) {
      return
    }

    
    
  }

  async handleResult(result) {
    let email = result.user.providerData[0].email;
    let profile = await firebase.firestore().collection("profiles").doc(email).get();
    
    if ( profile.exists ) {
      let data = profile.data();
      data.lastLogin = moment().valueOf();
      await firebase.firestore().collection("profiles").doc( email ).set( data ); 
    } else {

      let resp = await axios({
        method: 'get',
        url: 'https://prolific-coast-seeds.herokuapp.com/customer?email=' + email ,
      })


      await firebase.firestore().collection("profiles").doc( email ).set({ email, stripeCustomerId: resp.data.customer.id, created: moment().valueOf(), lastLogin: moment().valueOf() });

      window.location.href = "/subscribe"

    }

    
  }

  logout () {
    firebase
    .auth()
    .signOut()
    .then(function () { })

    this.setState({user: undefined})

    navigate("/")
  }

  button () {
    if ( this.state.manage ) {
     return     <Button>
     <a href={ this.state.manage } target="_blank">
     Manage
     </a>
   </Button>
    } else {
      return <Spinner />
    }
  }



  app () {
    if ( this.state.user && this.state.plan ) {
      return <Container style={{padding: "0px 20px"}}>
       <Box textAlign="center">
        <Heading size="sm" mb={4} color="gray.600" fontWeight="400"> 
          { this.state.plan } 
        </Heading>

        <ButtonGroup spacing={4} mb={8}>
          <Address parent={ this } />
      { this.button() }
    <Button onClick={ this.logout.bind(this) }>
      Logout
    </Button>
    </ButtonGroup>
    </Box>
        

    { this.forum() }

        
      </Container>
    } else if ( this.state.user ) {
      return <Box textAlign="center" pt={0}>

<ButtonGroup spacing={4} mb={6} alignContent="center">
    <Button onClick={ this.logout.bind(this) }>
      Logout
    </Button>
    </ButtonGroup>


     { this.grid() }

        
        </Box>
    } 
    
  }

  grid () {
    if ( this.state.gold) {
      return   <Box> <SimpleGrid columns={[1, 2, 3]} spacing={8} mb={8}>
      <Box>
      <Heading size="lg" mb={2}>Bronze</Heading> 


      <Stat pr={0} mb={2}>
  <StatNumber>$25</StatNumber>
  <StatHelpText>Per month</StatHelpText>

</Stat>

      <Button variantColor="red" rounded="full" data-id={ this.state.bronze.id } onClick={ this.checkout.bind(this) }>
        Subscribe
      </Button>


      <Box my={2} p={3}>
        I know 25$ a month isn't for everybody but if you are looking for regular growing content to help you get better in your garden, 25$ a month is a steal! 
      </Box>

      <Heading size="md" mb={1}>
        Premium Content Included
      </Heading>

      <Heading size="md">
        0 Seed Packs per month

      </Heading>

      </Box>

     

      <Box>
      <Heading size="lg" mb={2}>Silver</Heading>

      <Stat pr={0} mb={2}>
  <StatNumber>$50</StatNumber>
  <StatHelpText>Per month</StatHelpText>

</Stat>

      <Button variantColor="blue" rounded="full" data-id={ this.state.silver.id } onClick={ this.checkout.bind(this) }>
        Subscribe
      </Button>

      <Box my={2} p={3}>
        This is where we start to get serious! 50.00 a month will get you access to live Q&As where we can go direct to problem if you have one and talk it thru immediately in the chat! Once again, this tier might not be for you, but it might be just what you need to get you over the hump!

      </Box>

      <Heading size="md" mb={1}>
        Premium Content Included
      </Heading>
      <Heading size="md">
        1 Seed Pack per month

      </Heading>

     
      </Box>

      <Box>
        <Heading size="lg" mb={2}>Gold</Heading>
        <Stat pr={0} mb={2}>
  <StatNumber>$100</StatNumber>
  <StatHelpText>Per month</StatHelpText>

</Stat>
        <Button variantColor="yellow" rounded="full" data-id={ this.state.gold.id } onClick={ this.checkout.bind(this) }>
        Subscribe
      </Button>

        <Box my={2} p={3}>
        Well this is for the wave riders! If you support ProlificCoastSeed and like dope shit you found the place! This tier is much more personal...You get access to stuff the other tiers wont be able to see.. example, video walks thrus of other peoples facilities and private interviews with cannabis industry leaders on their tech and concepts and much much more ftw!
      </Box>

      <Heading size="md" mb={1}>
        Premium Content Included
      </Heading>

      <Heading size="md">
        2 Seed Packs per month
      </Heading>

      
      </Box>

    
    </SimpleGrid>
      <Box mb={4}>
        <Img fluid={ this.props.data.banner.childImageSharp.fluid } alt="Prolific Coast Banner" />
      </Box>
      </Box>
    } else {
      return <Box textAlign="center"><Spinner /></Box>
    }
  }

  forum () {
    return <SimpleGrid columns={[1, 2, 3 ,4 ]} spacing={12}>
      {
        this.props.data.forum.nodes.map( this.forumItem.bind(this) )
      }


    </SimpleGrid>
  }

  forumItem (node ) {

    if (!node.resources) {
      debugger
    }
    return <Link to={"forum/" + node.slug}>
      <PseudoBox cursor="pointer">
    
      <Box  mb={2} height="200px">
        <Img fluid={node.resources[0].fluid} alt={node.title} style={{height: "100%"}} imgStyle={{objectFit: "contain"}} />
      </Box>

    <Box   color="gray.800" height="100%">
        <Heading size="sm">
          {node.title}
        </Heading>

        
            { new moment(node.createdAt).format("MMMM Do YYYY") }
    </Box>


  </PseudoBox>
  </Link>
  }

  async checkout ( e ) {
    let id = e.currentTarget.dataset.id;
    const stripe =  await loadStripe('pk_live_ccEhvOS5yGirpesbKDOeagQh00T3UqtHwp');

    const {error} = await stripe.redirectToCheckout({
      // Make the id field from the Checkout Session creation API response
      // available to this file, so you can provide it as parameter here
      // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
      sessionId: id
    })
  }



  render() {
    return (
      <Layout>
        <SEO title="Subscribe" />

        <Styles>
          <Box bg="white" py={10} >
            <Container>
              <Heading textAlign="center" mt={4} mb={4}>Subscriptions</Heading>

              <div id="firebaseui-auth-container"></div>
              { this.app() }
              
            </Container>
            </Box>
        </Styles>
      </Layout>
    )
  }
}

export const query = graphql`
  {
    banner: file(relativePath: {eq: "retro-postcard-front.jpg"}) {
      childImageSharp {
        fluid(maxWidth: 950) {
          ...GatsbyImageSharpFluid
        }
      }
    }


    forum: allContentfulForum(sort: {fields: createdAt, order: ASC}) {
      nodes {
        id
        title
        slug
        createdAt
        updatedAt
       

        body {
          json
        }

        resources {
          fluid(maxWidth: 500) {
            ...GatsbyContentfulFluid
          }
        }
      }
    }
  }
`

function Address ( props ) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  let address = props.parent.state.customer.address || {};


  let line2Str = address.line2;
  if ( line2Str == "undefined")  {
    line2Str = ""
  }

  let [ name, setName ] = React.useState( props.parent.state.customer.name )
  let [ line1, setLine1 ] = React.useState( address.line1 )
  let [ line2, setLine2 ] = React.useState( line2Str )
  let [ city, setCity  ] = React.useState( address.city )
  let [ state, setState  ] = React.useState( address.state )
  let [ country, setCountry  ] = React.useState( address.country )
  let [ zip, setZip  ] = React.useState( address.postal_code )

  function update (e) {
    switch (e.currentTarget.dataset.path) {
      case "name":
        setName( e.currentTarget.value )
        break;

      case "line-1":
        setLine1( e.currentTarget.value )
        break;

      case "line-2":
        setLine2( e.currentTarget.value )
        break;

      case "city":
        setCity( e.currentTarget.value )
        break;

      case "state":
        setState( e.currentTarget.value )
        break;

      case "country":
        setCountry( e.currentTarget.value )
        break;

      case "zip":
        setZip( e.currentTarget.value )
        break;
  
      default:
        break;
    }
  }
  function handleSubmit (e) {
    e.preventDefault()
    props.parent.shipping({
      name, 
      line1, 
      line2, 
      city, 
      state, 
      postal_code: zip, 
      country, 
    })

    onClose()
  }

  function icon () {
    if ( props.parent.state.customer.address ) {
      return <Icon name="check-circle" color="green.500"  size="12px"   ml={1} />
    } else {
      return <Icon name="warning" size="12px" color="red.400" ml={1} position="relative"  />

    }
  }
  return (
    <>
      <Button onClick={onOpen} mr={4}>Shipping { icon() } </Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent maxWidth="600px">
        <form onSubmit={ handleSubmit }>


          <ModalHeader>Shipping information</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
          <FormControl mb={2} >
              <FormLabel>
                Name
              </FormLabel>
              <Input value={name} onChange={ update } data-path="name" />
            </FormControl>

            <SimpleGrid spacing={4} columns={[1, 2]} mb={2}>
            <FormControl isRequired>
              <FormLabel>
                Line 1
              </FormLabel>
              <Input value={line1} onChange={ update } data-path="line-1"  />
            </FormControl>

            <FormControl>
              <FormLabel>
                Line 2
              </FormLabel>
              <Input value={line2} onChange={ update } data-path="line-2"  />
            </FormControl>
            </SimpleGrid>

            <SimpleGrid spacing={4} columns={[1, 2]} mb={2}>

            <FormControl isRequired>
              <FormLabel>
                City 
              </FormLabel>
              <Input value={city} onChange={ update } data-path="city"  />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>
                State/Province/Region
              </FormLabel>
              <Input value={state} onChange={ update } data-path="state"  />
            </FormControl>
            </SimpleGrid>

            <SimpleGrid spacing={4} columns={[1, 2]} mb={2}>

            <FormControl isRequired>
              <FormLabel>
                Country
              </FormLabel>
              <Input value={country} onChange={ update } data-path="country"  />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>
                Zip/Postal Code
              </FormLabel>

              <Input value={zip} onChange={ update } data-path="zip"  />
            </FormControl>
            </SimpleGrid>

          </ModalBody>

          <ModalFooter>
            <Button  mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button  variantColor="green" type="submit">Update</Button>
          </ModalFooter>
          </form>

        </ModalContent>
      </Modal>
    </>
  );
}